import { delay } from 'redux-saga';
import { put, call, takeLatest, select } from 'redux-saga/effects';
import { NoteHistory } from '../constants/actionTypes';
import { getNoteHistoryContentsState } from '../reducers/NoteHistory/NoteHistoryReducer';
import ajax from '../utils/ajax';

function* getNoteHistoryListAsync(action) {
  const { noteId } = action;
  try {
    const { data } = yield call(ajax.getNoteHistoryList, noteId);
    yield put({ type: NoteHistory.GET_NOTE_HISTORY_LIST_SUCCESS, data });
  } catch (e) {
    yield put({ type: NoteHistory.GET_NOTE_HISTORY_LIST_FAIL });
  }
}

function* getNoteHistoryContentAsync(action) {
  const { historyId, isForce, noteId } = action;
  const noteHistoryContents = yield select(getNoteHistoryContentsState);
  let content = noteHistoryContents.getIn(['entities', historyId.toString()]);
  try {
    if (!content || isForce) {
      const { data } = yield call(ajax.getNoteHistoryContent, historyId, noteId);
      content = data;
    } else {
      yield delay(300);
    }
    // 从缓存中取到数据也需要更新status
    yield put({
      type: NoteHistory.GET_NOTE_HISTORY_CONTENT_SUCCESS,
      data: content,
      historyId,
    });
  } catch (e) {
    yield put({ type: NoteHistory.GET_NOTE_HISTORY_CONTENT_FAIL });
  }
}

function* restoreNoteHistoryContentAsync(action) {
  const { historyId, noteId, nbId } = action;
  const noteHistoryContents = yield select(getNoteHistoryContentsState);
  // 此处的revertData包含了title和content字段
  const revertData = noteHistoryContents.getIn(['entities', historyId.toString()]).toJS();
  try {
    const { data } = yield call(ajax.restoreHistoryContent, historyId, noteId);
    // 恢复版本成功后需要更新notes，所以需要nbId/noteId和content
    yield put({
      type: NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS,
      data,
      nbId,
      noteId,
      revertData,
    });
  } catch (e) {
    yield put({ type: NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_FAIL });
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* watchGetNoteHistoryList() {
  yield takeLatest(NoteHistory.GET_NOTE_HISTORY_LIST, getNoteHistoryListAsync);
}

export function* watchGetNoteHistoryContent() {
  yield takeLatest(NoteHistory.GET_NOTE_HISTORY_CONTENT, getNoteHistoryContentAsync);
}

export function* watchRestoreNoteHistoryContent() {
  yield takeLatest(NoteHistory.RESTORE_NOTE_HISTORY_CONTENT, restoreNoteHistoryContentAsync);
}



// WEBPACK FOOTER //
// ./src/sagas/NoteHistorySaga.js